<template>
  <div class="view admin contractors">
    <div class="page">
      <div class="header">
        <h3 class="text-black mt-2 mb-3">
          <strong>Contractors Management</strong>
        </h3>
      </div>
      <div class="content">
        <div class="card">
          <div class="card-header card-header-flex">
            <div class="d-flex flex-column justify-content-center mr-auto">
              <h5 class="mb-0">
                Contractors List
                <span :key="$store.getters['contractors/meta'].total" class="animated fadeIn"
                  >({{ $store.getters['contractors/meta'].total }})</span
                >
              </h5>
            </div>
            <div class="d-flex flex-column justify-content-center">
              <div class="">
                <a-button
                  type="default"
                  icon="sync"
                  class="mr-2"
                  @click="$store.dispatch('contractors/fetchContractors')"
                >
                  Refresh
                </a-button>
                <a-button type="primary" icon="user" @click="$store.dispatch('contractors/openModal', 'create')">
                  New Contractor
                </a-button>
              </div>
            </div>
          </div>
          <!-- table -->
          <a-table
            :loading="$store.getters['contractors/loading']"
            :columns="columns"
            :dataSource="contractors"
            :rowKey="(contractor, index) => contractor._id"
            :customRow="rowClick"
            :scroll="{ x: 1200 }"
            :pagination="pagination"
            @change="change"
          >
            <span slot="status" slot-scope="status">
              <span class="font-size-12 badge" :class="statusClass(status)">{{ status }}</span>
            </span>

            <span slot="type" slot-scope="type">
              {{ type | CONTRACTOR_TYPE_ }}
            </span>

            <span slot="superadmin" slot-scope="superadmin">
              <span> {{ superadmin.username }} </span>
            </span>

            <span slot="created_by" slot-scope="created_by">
              <span> {{ created_by.display_name }} </span>
            </span>

            <span slot="created_at" slot-scope="created_at">
              <span> {{ created_at | moment('l') }} </span>
            </span>
          </a-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import router from '@/router'

export default {
  async beforeRouteEnter(to, from, next) {
    store.commit('contractors/INIT')
    await store.dispatch('contractors/fetchContractors')
    next()
  },
  data() {
    return {
      columns: [
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
          fixed: 'left',
          width: '120px',
        },
        {
          title: 'Status',
          dataIndex: 'status',
          key: 'status',
          align: 'center',
          filters: [
            {
              text: 'Pending',
              value: 'pending',
            },
            {
              text: 'Active',
              value: 'active',
            },
          ],
          filterMultiple: false,
          onFilter: (status, contractor) => contractor.status.indexOf(status) === 0,
          scopedSlots: { customRender: 'status' },
        },
        {
          title: 'Type',
          dataIndex: 'type',
          key: 'type',
          width: '120px',
          scopedSlots: { customRender: 'type' },
        },
        {
          title: 'Email',
          dataIndex: 'email',
          key: 'email',
          width: '180px',
        },
        {
          title: 'Phone',
          dataIndex: 'phone',
          key: 'phone',
        },
        {
          title: 'Location',
          dataIndex: 'location',
          key: 'location',
        },
        {
          title: 'Superadmin',
          dataIndex: 'superadmin',
          key: 'superadmin',
          scopedSlots: { customRender: 'superadmin' },
        },
        {
          title: 'Creator',
          dataIndex: 'created_by',
          key: 'created_by',
          scopedSlots: { customRender: 'created_by' },
        },
        {
          title: 'Creation',
          dataIndex: 'created_at',
          key: 'created_at',
          scopedSlots: { customRender: 'created_at' },
        },
      ],
    }
  },
  methods: {
    rowClick: (record) => ({
      on: {
        click: (e) => router.push({ name: 'admin-contractor', params: { id: record._id } }),
      },
    }),
    change: (pagination, filters, sorter) => {
      store.dispatch('contractors/setQuery', { pagination, filters, sorter })
    },
  },
  computed: {
    contractors: () => store.getters['contractors/contractors'],
    pagination: () => store.getters['contractors/pagination'],
  },
  destroyed() {
    store.commit('contractors/INIT')
  },
}
</script>

<style lang="scss" scoped></style>
